<template lang="pug">
.supercharged-entertainment-container
  .page-buy-play-card.buy-play-cards-with-upgrades
    .book-form
      form(@submit.prevent="addToCartAndGo")
        agree-to-terms.book-form__agreement(v-model="termsAgreed")
        re-group-box.book-form__tab.playcard-amount(:class="{ disabled: !termsAreAgreed }")
          template(slot="title") How many play cards would you like to purchase?
          span.book-form__tab__number 1
          p A new card fee of $0.50 will be taken from the balance of each card purchased.
          .playcard-quantity
            label Quantity
            input.book-form__input-full(v-model="playcardQuantity" type="number" min="1" step="1" @input="$v.playcardQuantity.$reset")

        re-group-box.book-form__tab.playcard-amount(:class="{ disabled: !termsAreAgreed }")
          template(slot="title") What attractions would you like to add to your card?
          span.book-form__tab__number 2
          p.info-note Every attraction requires a purchase of extra credits that will be added to the play card.

          .border-box(v-for="(card, index) in cards")
            .card-detail.card-detail--first
              .card-detail-name.card-detail-name--arcade-card Arcade card
              .card-detail-input
                label Select amount
                select(v-model="card.productId" @input="$v.cards.$each[index].productId.$reset")
                  option(v-for="{ id, title } in playcardProducts" :value="id") {{ title }}
            template(v-for="upgrade in cardProduct(card).upgrades")
              .card-detail
                .card-detail-name {{ upgrade.title }}
                .card-detail-input
                  .rides-input-box
                    button.text-button.text-button--minus(
                      :class="{ disabled: card.upgrades[upgrade.name] < 1 }"
                      @click.prevent="card.upgrades[upgrade.name]--"
                    ) –
                    .racer-quantity-value {{ card.upgrades[upgrade.name] || 0 }}
                    button.text-button(
                      :class="{disabled: upgrade.max_count != null && upgrade.max_count != '' && card.upgrades[upgrade.name] >= upgrade.max_count }"
                      @click.prevent="card.upgrades[upgrade.name]++"
                    ) +
                p.info-note The cost of {{ upgrade.title }} is {{ upgrade.price | currency }}.

        re-content-placeholder(name="purchase_card_below_product_selection")
        include ../../components/global/parts/views/personal-details.pug

        re-group-box.book-form__tab.booking-cart-display-box(:class="{ disabled: !showMiniCart }" v-show="showMiniCart")
          template(v-slot:title) PRICING SUMMARY
          span.book-form__tab__number 4
          .mini-cart
            mini-cart(:cards="cards" :playcard-products="playcardProducts")

        would-you-like-to.m-t-30(v-if="!editMode" exclude="supercharged.buy-play-card" @before-route="likeClick")

        .book-form__add-to-cart
          v-button.site_button.site_button_inverse(:disabled="isAnyInvalid" :loading="isAddingToCart")
            span {{ editMode ? 'Update Cart' : 'Add to Cart' }}
</template>

<script>
import { required, minValue, integer } from 'vuelidate/lib/validators'
import ConfigMixin from '../../components/_mixins/config'
import PagesMixin from '../../components/_mixins/pages'
import PersonalDetailsMixins from '../../components/_mixins/personal-details'
import LocationMixin from 'utils/vue/mixins/location'
import AgreeToTerms from '../../components/parts/AgreeToTerms'
import BonusBox from '../../components/parts/BonusBox'
import WouldYouLikeTo from '../../components/parts/would-you-like-to'
import MiniCart from './mini-cart'
import {getQS} from '../../lib/utils'
const qs = getQS() || {}

const mixins = [
  ConfigMixin,
  PagesMixin,
  PersonalDetailsMixins,
  LocationMixin
]

try {
  mixins.push(require('marketing/playcards/_mixins/buy-playcard-form').default)
} catch (e) {}

export default {
  name: 'page-buy-play-cards-with-upgrades',

  components: {
    AgreeToTerms,
    BonusBox,
    WouldYouLikeTo,
    MiniCart,
  },

  mixins,

  data: () => ({
    termsAgreed: 'no',

    firstName: null,
    lastName: null,
    phone: null,
    email: null,

    playcardQuantity: 1,

    cards: [],
  }),

  computed: {
    termsAreAgreed() {
      return this.termsAgreed == 'yes'
    },
    disabledPersonalDetails() {
      return !this.termsAreAgreed
    },
    isAnyInvalid() {
      return !this.termsAreAgreed || this.addingToCartDisabled || this.$v.personalDetails.$invalid
    },
    addingToCartDisabled() {
      return this.$v.cards.$error || this.$v.cards.$invalid
    },
    showMiniCart() {
      return this.termsAreAgreed
    },
  },

  watch: {
    playcardQuantity() {
      while (this.cards.length > this.playcardQuantity) {
        this.cards.pop()
      }
      this.fillCards()
    },
  },

  validations() {
    return {
      playcardQuantity: {
        required,
        minValue: minValue(1),
        integer,
      },
      cards: {
        $each: {
          productId: {
            required,
          },
        }
      },
      ...(this.addedValidations ? this.addedValidations() : {})
    }
  },

  created() {
    this.personalDetailsStepNumber = 3

    if (qs.item || this.$route.query.item) {
      this.setEditItems(qs.item || this.$route.query.item)
    }

    if (!this.editMode) {
      this.fillCards()
    } else {
      this.termsAgreed = 'yes'
      this.$nextTick(function () {
        this.firstName = _.get(this.editItem, 'payload.options.contact.first_name')
        this.lastName = _.get(this.editItem, 'payload.options.contact.last_name')
        this.phoneConfirmation = this.phone = _.get(this.editItem, 'payload.options.contact.phone')
        this.emailConfirmation = this.email = _.get(this.editItem, 'payload.options.contact.email')
      })
    }

    this.$v.$touch()
  },

  methods: {
    setEditItems(id) {
      if (this.cartItems[id] && this.cartItems[id].type === 'playcard_voucher') {
        this.editItem = this.cartItems[id]
        let parentId = this.editItem.payload.options.parent_id
        if (parentId) {
          this.editItem = this.cartItems[parentId]
        } else {
          parentId = id
        }

        this.cards.push({
          productId: this.editItem.payload.product_id,
          upgrades: _.cloneDeep(this.editItem.payload.options.upgrades),
        })

        for (const childId of this.editItem.payload.options.child_ids) {
          const childItem = this.cartItems[childId]
          this.cards.push({
            productId: childItem.payload.product_id,
            upgrades: _.cloneDeep(childItem.payload.options.upgrades),
          })
        }

        this.editMode = true
        this.playcardQuantity = this.cards.length
      }
    },

    fillCards() {
      while (this.cards.length < this.playcardQuantity) {
        this.cards.push({
          productId: this.playcardProducts[0].id,
          upgrades: Object.fromEntries(
            this.playcardProducts[0]
              .upgrades
              .map(upgrade => [upgrade.name, 0])
          ),
        })
      }
    },

    async addToCartAndGo() {
      await this.addToCart()
      this.$router.push({ name: 'racewaybooking.checkout' })
    },

    async addToCart() {
      if (this.editItem) {
        for (const childId of this.editItem.payload.options.child_ids) {
          this.removeCartItem({ id: childId })
         }
         this.removeCartItem(this.editItem)
      }

      let firstItem = null
      const firstId = (new Date).getTime()
      const childIds = []

      for (let index in this.cards) {
        const card = this.cards[index]

        index = parseInt(index)

        const item = this.getPlaycardCartItem(card)
        item.id = firstId + index

        if (index) {
          // item.attributes.skipCartCount = true
          item.payload.options.parent_id = firstItem.id
          childIds.push(item.id)
        } else {
          firstItem = item
        }

        item.payload.options.contact = {
          first_name: this.firstName,
          last_name: this.lastName,
          phone: this.phone,
          email: this.email,
        }

        await this.addPlaycardCartItem(item)
      }

      firstItem.payload.options.child_ids = childIds
    },

    likeClick() {
      if (this.termsAreAgreed && !this.addingToCartDisabled) {
        this.addToCart()
      }
    },

    getPlaycardCartItem(card) {
      const playcardProduct = this.cardProduct(card)

      const total = Number(playcardProduct.price) +
        Object.entries(card.upgrades)
            .map(([name, count]) => playcardProduct.upgrades.find(u => u.name == name).price * count)
            .reduce((sum, a) => sum + a, 0)

      const item = {
        type: 'playcard_voucher',
        total,
        count: 1,
        payload: {
          product_id: card.productId,
          count: 1,
          options: {
            upgrades: card.upgrades,
          },
        },
        editable: true,
        attributes: {
          product: playcardProduct,
          disableCountControls: true,
        },
      }

      if (this.editMode) {
        item.id = this.editItem.id
      }

      return item
    },

    cardProduct(card) {
      return this.playcardProducts.find(x => x.id == card.productId)
    },
  }
}
</script>
